import { h, defineComponent } from 'vue'
export default defineComponent({
  name: 'Loading',
  render() {
    return (
      <svg
        class="loading"
        viewBox="0 0 1024 1024"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M270.4 214.4C336 160 420 128 512 128c212 0 384 172 384 384h64c0-247.2-200.8-448-448-448-107.2 0-205.6 37.6-282.4 100l40.8 50.4z"
          fill="currentColor"
        ></path>
      </svg>
    )
  }
})
